import React, {
  MouseEvent,
  PropsWithChildren,
} from 'react';
import CopyIcon from '@mui/icons-material/ContentCopyRounded';
import IconButton from '@mui/material/IconButton';
import {
  useNotify,
} from 'core/hooks';
import ToolTip from 'core/components/Tooltip';
import clsx from 'clsx';

type Parts = 'root' | 'icon';

type Props = PropsWithChildren & {
  text?: string;
  successMessage?: string;
  tooltip?: string;
  ariaLabel?: string;
  className?: string;
  classes?: Partial<Record<Parts, string>>;
};

export default function CopyWrapper({
  children,
  text = '',
  tooltip = 'Copy',
  ariaLabel,
  successMessage,
  className,
  classes,
}: Props) {
  const notify = useNotify();
  const onCopy = async (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      notify({
        variant: 'success',
        message: successMessage ?? `"${text}" was copied to clipboard.`,
      });
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <>
      <ToolTip title={tooltip}>
        <IconButton
          aria-label={ariaLabel}
          onClick={onCopy}
          size="small"
          className={clsx(className, classes?.root)}
        >
          <CopyIcon className={clsx('!w-4 !h-4 !text-gray-500', classes?.icon)} />
        </IconButton>
      </ToolTip>
      {children}
    </>
  );
}
